import { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import Loader from 'ui/components/Loader'

function Login() {
  const { oktaAuth, authState } = useOktaAuth()
  const navigate = useNavigate()
  useEffect(() => {
    const login = async () => {
      if (!authState) {
        return
      }

      if (authState.isAuthenticated) {
        navigate('/')
      } else {
        try {
          await oktaAuth.signInWithRedirect()
        } catch (error) {
          console.error('Error during login:', error)
        }
      }
    }

    login()
  }, [oktaAuth, authState])

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Loader isLoading />
    </Box>
  )
}

export default Login
